import { jsx as H } from "react/jsx-runtime";
import { SmartLink as I } from "../../SmartLink/index.js";
import { isPublicHttpUrl as o } from "../../../services/url/index.js";
const B = ({
  domElement: L,
  renderChildren: d,
  clickoutFunction: T
}) => {
  const { children: k, attribs: n, parent: h } = L, r = k || (h == null ? void 0 : h.children) || [], e = n == null ? void 0 : n.href, W = (n == null ? void 0 : n["data-mention"]) && (e == null ? void 0 : e.includes("perfil")), g = r.some((t) => t.type === "tag"), a = (() => {
    var i, s, c, l, m, f;
    if (g)
      return "";
    let t = r.map((p) => p.data || "").join(" ");
    if ((i = r[0]) != null && i.parent && ((l = (c = (s = r[0].parent) == null ? void 0 : s.next) == null ? void 0 : c.data) != null && l.match("^[,;]+"))) {
      const p = (f = (m = r[0].parent) == null ? void 0 : m.next) == null ? void 0 : f.data, w = p ? p.split(" ") : "", $ = w.length ? w[0] : "";
      $ && $.match("^[,;]+") && (t = `${t}${$}`);
    }
    return o(`https://${t}`) ? `https://${t}` : t;
  })(), x = (() => {
    if (e) {
      if (o(e))
        return e;
      if (o(`https://${e}`))
        return `https://${e}`;
    }
    return o(a) ? a : null;
  })(), u = W ? new URL(e).pathname : x ? T({ url: x }) : e;
  return u ? /* @__PURE__ */ H(
    I,
    {
      url: u,
      target: "_blank",
      rel: "ugc nofollow noreferrer noopener",
      children: g ? d() : (() => {
        const t = a || u;
        if (o(t)) {
          const { host: i, pathname: s, search: c } = new URL(t), l = i.replace(/^www.*?\./, ""), f = `${s.replace(/\/$/, "")}${c}`.replace(
            /^(.{2}).*(.{2})$/,
            "$1...$2"
          );
          return `${l}${f}`;
        }
        return a;
      })()
    }
  ) : /* @__PURE__ */ H("span", { children: d() });
};
export {
  B as linkInterceptor
};
